import styled, { css } from "styled-components";

export const HeadingWrapper = styled.div`
  ${({ theme }) => css`
    margin: ${theme.tokens.sizes.spacings.byte} 0;
  `}
`;
